import { TranRecordModel } from "./tran-record.model";

export class UpdateStatusModel {
    tranRecord: TranRecordModel
    strStatus: string

    constructor(
        tranRecord: TranRecordModel,
        strStatus: string
    ) {
        this.tranRecord = tranRecord
        this.strStatus = strStatus
    }
}